import { RootStores } from '@/store/core/RootStore';

export default abstract class StoreConstructor {
  stores: RootStores;

  constructor(stores: RootStores) {
    this.stores = stores;
  }
}
